import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {hrTicketsTableReady,rowsPerPageState,searchTextState,paginationState,hrTicketsIdForAction,previousFilterStartDate,previousFilterEndDate,previousFilterCity} from '../redux/hr'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import * as Helpers from '../../../common/helpers'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/hrTable.css'



import {Cities} from '../../../common/DropDowns/index'




import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'

import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'


function filterUnwantedData(hrTicketsData) {
    let array = []
    if (hrTicketsData && hrTicketsData.data && hrTicketsData.data.list) {
        array = hrTicketsData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.contact_no = lineData.contact_no ? lineData.contact_no : "NA"
            newLineData.issue_remarks = lineData.issue_remarks ? lineData.issue_remarks : "NA"
            newLineData.hr_remarks =lineData.hr_remarks ? lineData.hr_remarks : "NA"
            newLineData.type =lineData.type ? lineData.type : "NA"
            newLineData.status =lineData.status ? lineData.status : "NA"
            newLineData.created =lineData.created ? lineData.created : "NA"
            newLineData.assigned_hr =lineData.assigned_hr && lineData.assigned_hr.name ? lineData.assigned_hr.name : "NA"
            newLineData.issue_reason =lineData.issue && lineData.issue.name ? lineData.issue.name : "NA"
            newLineData.employee_id =lineData.employee && lineData.employee.code ? lineData.employee.code : "NA"
            newLineData.employee_name =lineData.employee && lineData.employee.name ? lineData.employee.name : "NA"

            newLineData.work_location ="NA"

            if(lineData.employee && lineData.employee.work_location_type==="OFFICE"){
                 newLineData.work_location=lineData.employee && lineData.employee.office_work_location  && lineData.employee.office_work_location.name ? lineData.employee.office_work_location.name : "NA"
            }else{                
                 newLineData.work_location=lineData.employee && lineData.employee.kitchen_work_location  && lineData.employee.kitchen_work_location.name ? lineData.employee.kitchen_work_location.name : "NA"
            }
            newLineData.city_name =lineData.employee && lineData.employee.city && lineData.employee.city.name ? lineData.employee.city.name : "NA"

            
            newArray[i] = newLineData
        }
    }
    return newArray
}


class HRTicketsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            hrTicketsData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_city_id:"",
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            ranges: {
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
            
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(hrTicketsTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.HR_TICKETS_TABLE))
        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()


         let previousFilterStartDate=moment().startOf('month').format("YYYY-MM-DD")
            let previousFilterEndDate=moment().format("YYYY-MM-DD")
            let previousFilterCity=""

         if (this.props.hr && this.props.hr.previousFilterStartDate && this.props.hr.previousFilterStartDate!==undefined) {
            previousFilterStartDate=this.props.hr.previousFilterStartDate
         }
         if (this.props.hr && this.props.hr.previousFilterEndDate && this.props.hr.previousFilterEndDate!==undefined) {
            previousFilterEndDate=this.props.hr.previousFilterEndDate
         }
         if (this.props.hr && this.props.hr.previousFilterCity && this.props.hr.previousFilterCity!==undefined) {
            previousFilterCity=this.props.hr.previousFilterCity
         }

         this.setState({
              filter_city_id:previousFilterCity,
              startDate:previousFilterStartDate,
              endDate:previousFilterEndDate
         },() => {
            this.getHRTicketsData()
        });


        
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }


     onApplyEvent = (event, picker) => {
        let startDate = moment(picker.startDate)
        let endDate = moment(picker.endDate)

        let api_start_date=moment(picker.startDate).format("YYYY-MM-DD")
        let api_end_date=moment(picker.endDate).format("YYYY-MM-DD")
        if (endDate.diff(endDate, 'months', true) > 1) {
            this.dialog.show({
                title: "Date chosen is greater than one month",
                body: 'Please choose any Dates within one month and then try again',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        } else {
            if (startDate.isAfter(moment().add(1, 'days')) ||
                endDate.isAfter(moment().add(1, 'days'))) {
                this.dialog.show({
                    title: "Date Chosen is greater than current date",
                    body: 'Please choose any Dates within current date and then try again',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            } else {

                this.props.dispatch(previousFilterStartDate(api_start_date))
                this.props.dispatch(previousFilterEndDate(api_end_date))

                this.setState({
                    startDate: api_start_date,
                    endDate: api_end_date
                })
            }
        }
    }
    
    getHRTicketsData = () => {
        apiService.getHRTicketsData(this.state.startDate,this.state.endDate,this.state.filter_city_id)
            .then(hrTicketsData => {
                if (hrTicketsData && this.isComponentMounted) {
                    this.validateBuildNumber(hrTicketsData)
                    if (hrTicketsData.status === "SUCCESS") {
                        let array = filterUnwantedData(hrTicketsData), pageNo = 1
                        if (this.props.hr && this.props.hr.previousPaginationValue) {
                            pageNo = this.props.hr.previousPaginationValue
                        }
                        this.setState({
                            hrTicketsData: array,
                            page: pageNo,
                        })


                        this.createCSVData(array)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: hrTicketsData.reason ? hrTicketsData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(hrTicketsTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(hrTicketsTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.hr && this.props.hr.previousRowsPerPageValue) {
            value = this.props.hr.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }


    createCSVData(csvData) {
        let ticketList = []
        if (csvData) {
            ticketList = JSON.parse(JSON.stringify(csvData))
            ticketList = createXLSheetdata(ticketList)
        }
        this.CSVData = ticketList
    }



    cityChange = (data) => {

        
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
              this.setState({
                filter_city_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
            filter_city_id :data.value,
            
            })
        }
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

     renderLocation = (cell, row, enumObject, rowIndex,) => {
        
        let location=""
        
            location=<p>{row.work_location} - {row.city_name}</p>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{location}</div>
        </div>)
    }



    renderCreatedFormat = (cell, row, enumObject, rowIndex,) => {
                let dateTemp="NA"

        if(row.created){
            dateTemp=Helpers.getDateTimeFormatForUTC(row.created)
        }
        
         
        return (<p>{dateTemp}</p>)
    }

      renderHrRemarks = (cell, row, enumObject, rowIndex,) => {
                let remarks=""

        remarks=<p class="more-text" title={row.hr_remarks}>{row.hr_remarks}</p>
        
         
        return (<span>{remarks}</span>)
    }


      renderIssuerRemarks = (cell, row, enumObject, rowIndex,) => {
                let issuerRemarks=""

        issuerRemarks=<p class="more-text" title={row.issue_remarks}>{row.issue_remarks}</p>
        
         
        return (<span>{issuerRemarks}</span>)
    }

    




   

    createCustomToolBar = props => {


        let ticketDetailsFilename = "hrTickets" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"


        let startDate = "", endDate = "", start = "", end = "", label = ""

        startDate = moment(this.state.startDate)
        endDate = moment(this.state.endDate)

        start = moment(startDate).format('DD-MM-YYYY')
        end = moment(endDate).format('DD-MM-YYYY')

        label = start + ' to ' + end;

        if (start === end) {
            label = start
        }

        let firstComponent = ''

        
            firstComponent = <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                <div className="form-group">
                    <DateRangePicker startDate={startDate}
                        endDate={endDate}
                        ranges={this.state.ranges}
                        showDropdowns={true}
                        onApply={this.onApplyEvent}>
                        <button className="date-picker-button">
                            <div className="pull-left"><i className="fa fa-calendar" /></div>
                            <span style={{ textAlign: 'center' }}>{label}</span>
                            <div className="pull-right">
                                <span className="caret"></span>
                            </div>
                        </button>
                    </DateRangePicker>
                </div>
            </div>


        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">


{(() =>{

    if(Helpers.checkPrivileges("/dashboard/hr/hrtickets/addEdit",this.props.user)){
        return(
                <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.dispatch(hrTicketsIdForAction())
                                this.props.history.push("/dashboard/hr/hrtickets/addEdit")
                            }}>
                            Add
                        </button>
                    </div>

            )
        }
})()}

                    {firstComponent}

                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city_id} />   
                    </div>
                    </div>

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredhRTicketList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>

                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={ticketDetailsFilename}>
                            Export
                        </CSVLink>
                    </div>
                   
                   
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
   
   createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.hrTicketsData.length>=(this.props.hr.previousPaginationValue*this.props.hr.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.hr.previousPaginationValue*this.props.hr.previousRowsPerPageValue)-this.props.hr.previousRowsPerPageValue+1} to {this.props.hr.previousPaginationValue*this.props.hr.previousRowsPerPageValue} of {this.state.hrTicketsData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.hr.previousPaginationValue*this.props.hr.previousRowsPerPageValue)-this.props.hr.previousRowsPerPageValue+1} to {this.state.hrTicketsData.length} of {this.state.hrTicketsData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }


    getFilteredhRTicketList = () => {
       
        this.props.dispatch(hrTicketsTableReady(false))
        this.resetSearchAndPagination()
        this.getHRTicketsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    

    resetFilterValues = () => {
        this.props.dispatch(hrTicketsTableReady(false))
        this.setState({
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            filter_city_id:""
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterCity(""))
            this.props.dispatch(previousFilterStartDate(moment().startOf('month').format("YYYY-MM-DD")))
            this.props.dispatch(previousFilterEndDate(moment().format("YYYY-MM-DD")))

        this.getHRTicketsData();
        });
    }


    actionButtonsCreator = (cell, row) => {
        let editButton =""

        if(row.status==="ASSIGNED"){


if(Helpers.checkPrivileges("/dashboard/hr/hrtickets/addEdit",this.props.user)){
        
            editButton=<button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.edithRTicket(row)
                }}>
                Edit
            </button>
        }

            }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.hr && this.props.hr.previousPaginationValue
            && this.props.hr.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    edithRTicket = (row) => {
        if (row && row.id) {
            this.props.dispatch(hrTicketsIdForAction(row.id))
            this.props.history.push("/dashboard/hr/hrtickets/addEdit")
        } else {
            this.dialog.show({
                title: "hRTicket Identification number not found",
                body: 'hRTicket id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.hr && this.props.hr.previousRowsPerPageValue) {
            sizeperPage = this.props.hr.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="hRTickets-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.hrTicketsData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
                    
                     {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}

                    <TableHeaderColumn
                        dataField="employee_id"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp. Id
                    </TableHeaderColumn>                   
                    
                    <TableHeaderColumn
                        dataField="employee_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>              
                    
                    <TableHeaderColumn
                        dataField="contact_no"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Contact
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}
                        dataFormat={this.renderLocation}>
                       Location
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="type"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Type
                    </TableHeaderColumn> 
                    <TableHeaderColumn
                        dataField="issue_reason"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Issue
                    </TableHeaderColumn>  

                    <TableHeaderColumn
                       
                        dataFormat={this.renderIssuerRemarks}
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}
                        tdClassName="more-text-td">
                       Issuer Remarks
                    </TableHeaderColumn>         
                    
                    <TableHeaderColumn
                        //dataField="hr_remarks"
                        dataFormat={this.renderHrRemarks}
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}
                        tdClassName="more-text-td">
                       HR Remarks
                    </TableHeaderColumn>         
                    
                    <TableHeaderColumn
                        dataField="assigned_hr"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Assigned To
                    </TableHeaderColumn>     
                    <TableHeaderColumn
                        dataField="status"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Status
                    </TableHeaderColumn>                   
                    
                    <TableHeaderColumn
                        dataFormat={this.renderCreatedFormat}
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Created On
                    </TableHeaderColumn>                   
                    
                    
                     <TableHeaderColumn
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        hr: state.hr
    }
}

export default connect(mapStateToProps)(withRouter(HRTicketsTable))


// WEBPACK FOOTER //
// ./src/modules/HR/Components/HRTicketsTable.js